import { PressCoverageItem } from "modules/press/components/PressCoverageItem";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { PressItemProps } from "modules/press/components/types.d";

const PressCoverageItemAdapter = ({ blok: { href, image, title } }: ReactStoryblokComponent<PressItemProps>) => (
  <PressCoverageItem href={href} image={image} title={title} />
);

export default PressCoverageItemAdapter;
